import { SourcingAnalytics } from 'api-clients/monolith';
import { useMemo } from 'react';
import { useIntl } from 'react-intl';

import CurrencyDollar from '@/assets/icons/currency-dollar-blue.svg';
import Identification from '@/assets/icons/identification-blue.svg';
import Users from '@/assets/icons/users.svg';

export function useMetricContent({
  metricKey,
}: {
  metricKey: keyof SourcingAnalytics;
}) {
  const intl = useIntl();

  return useMemo(() => {
    switch (metricKey) {
      case 'budget_spent':
        return {
          label: intl.formatMessage({
            defaultMessage: 'Spend',
            description: 'Dashboard org analytics: money spent in period',
          }),
          icon: CurrencyDollar,
        };
      case 'hired_count':
        return {
          label: intl.formatMessage({
            defaultMessage: 'Hired',
            description: 'Dashboard org analytics: number of people hired',
          }),
          icon: Identification,
        };
      case 'average_cph':
        return {
          label: intl.formatMessage({
            defaultMessage: 'Avg CPH',
            description:
              'Dashboard org analytics: average cost per hire (acronym CPH kept short)',
          }),
          icon: CurrencyDollar,
        };
      case 'applied_count':
        return {
          label: intl.formatMessage({
            defaultMessage: 'Applied',
            description: 'Dashboard org analytics: how many people applied',
          }),
          icon: Users,
        };
      case 'average_cpa':
        return {
          label: intl.formatMessage({
            defaultMessage: 'Avg CPA',
            description:
              'Dashboard org analytics: average cost per applicant (acronym CPA kept short)',
          }),
          icon: CurrencyDollar,
        };
      default:
        return {
          label: '',
          icon: '',
        };
    }
  }, [intl, metricKey]);
}
